const PDF = require('pdf/PDF');
const config = require('core/config');
const uaParser = new (require('ua-parser-js'))();
const logger = require('utilities/logger');

module.exports = {
	methods: {
		print: function (target, options) {
			options = options || {};

			options.scale = 0.65;
			options.widowThreshold = 0.2;

			if (options.header) {
				options.header =
					'<img style="width:110px;height:17px" src="' +
					(config.resources.assets.cdn || config.resources.assets.origin) +
					'/assets/dist/images/rw-bw.jpeg"><span class="vertically-centered" style="top:95%;right:0;font-size:0.75rem">' +
					options.header +
					'</span>';
			}
			var pdfWindow;

			if (uaParser.getBrowser().name !== 'IE' && uaParser.getBrowser().name !== 'Edge') {
				// TODO test edge
				pdfWindow = window.open('', '_blank');
			}

			return new PDF(target, options)
				.generate()
				.then(function (result) {
					var blob = result.blob;

					if (pdfWindow) {
						pdfWindow.location.href = global.URL.createObjectURL(blob);
					} else {
						window.navigator.msSaveOrOpenBlob(blob, (options.filename || 'ReadWorks download') + '.pdf');
					}
				})
				.catch(function (error) {
					logger.error(error.stack || error);
				});
		}
	}
};
